<template>
  <div>
    <div
      class="alert text-left formatted-text"
      :class="{
        'alert-danger': message.error,
        'alert-success': !message.error,
      }"
      role="alert"
      v-show="message.display"
    >
      {{ this.message.content }}
    </div>
    <div class="row">
      <div class="col-md-6">
        <form>
          <fieldset>
            <legend class="view-legend">PERSONNEL</legend>
            <div class="form-group row">
              <label class="col-md-3 text-right">Nom:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                demand.lastname
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Prénom(s):</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ demand.firstname }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Sexe:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                demand.gender === "male" ? "Masculin" : "Féminin"
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Date naissance:</label>
              <label
                v-if="demand.birth_date"
                type="text"
                class="col-md-8 text-left font-weight-bold"
              >
                {{
                  demand.birth_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Lieu naissance:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                demand.birth_place
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Pays naissance:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                demand.birth_country_name
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Nationalité:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                demand.citizenship_country_name
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Autre nationalité:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                demand.other_citizenship_country_name
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Pays résidence:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                demand.residencce_country_name
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Profession:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                demand.occupation
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Téléphone:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                demand.contact01
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Autre téléphone:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                demand.contact02
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Adresse:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                demand.adress
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Email:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                demand.email
              }}</label>
            </div>
          </fieldset>
        </form>
      </div>
      <div class="col-md-6">
        <form>
          <fieldset>
            <legend class="view-legend">VOYAGE</legend>
            <div class="form-group row">
              <label class="col-md-5 text-right"
                >Date du précédent séjour au Bénin:</label
              >
              <label
                v-if="demand.previous_stayin_date"
                type="text"
                class="col-md-7 text-left font-weight-bold"
              >
                {{
                  demand.previous_stayin_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right">Date Entrée au Bénin:</label>
              <label
                v-if="demand.arrival_date"
                type="text"
                class="col-md-7 text-left font-weight-bold"
                >{{
                  demand.arrival_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}</label
              >
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right"
                >Date de départ du Bénin:</label
              >
              <label
                v-if="demand.departure_date"
                type="text"
                class="col-md-7 text-left font-weight-bold"
                >{{
                  demand.departure_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}</label
              >
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right">
                Adresse de résidence au Bénin:
              </label>
              <label type="text" class="col-md-7 text-left font-weight-bold">
                {{ demand.local_adress }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right">Durée du séjour:</label>
              <label type="text" class="col-md-7 text-left font-weight-bold">
                {{ demand.stayin_duration }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right"
                >Destination suivante après Bénin:
              </label>
              <label type="text" class="col-md-7 text-left font-weight-bold">
                {{ demand.country_after_departure_name }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right">Moyens de subsistance:</label>
              <label type="text" class="col-md-7 text-left font-weight-bold">
                {{ demand.stayin_garanty }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right">Garantie de retour:</label>
              <label type="text" class="col-md-7 text-left font-weight-bold">
                {{ demand.return_garanty }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right">Motif du voyage:</label>
              <label type="text" class="col-md-7 text-left font-weight-bold">
                {{ demand.travel_purpose }}
              </label>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <form>
          <fieldset>
            <legend class="view-legend">E-VISA</legend>
            <div class="form-group row">
              <label class="col-md-3 text-right">Référence: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ demand.reference }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Type de l'eVisa: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ demand.visatype_name }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Durée de l'eVisa: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ demand.visatype_duration }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Demande en ambassade: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ demand.priority ? "Oui" : "Non" }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Coût de l'eVisa: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ demand.amount }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Recherché: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                <span
                  :class="{
                    'badge badge-success': !demand.matched,
                    'badge badge-danger': demand.matched,
                  }"
                  >{{ demand.matched ? demand.matched : "Non" }}</span
                >
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Statut: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                <span
                  :class="{
                    'badge badge-success': demand.state === 'GENERATED',
                    'badge badge-warning': [
                      'VALIDATION',
                      'PROCESSSING',
                    ].includes(demand.state),
                  }"
                >
                  {{ DEMAND_STATUS_TRANSLATION[demand.state] }}
                </span>
              </label>
            </div>
            <div v-if="demand.visa_issuing_date" class="form-group row">
              <label class="col-md-3 text-right">Généré le: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{
                  demand.visa_issuing_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}
              </label>
            </div>
            <div v-if="demand.visa_expiry_date" class="form-group row">
              <label class="col-md-3 text-right">Expire le: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{
                  demand.visa_expiry_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}
              </label>
            </div>
          </fieldset>
        </form>
      </div>
      <div class="col-md-6">
        <form>
          <fieldset>
            <legend class="view-legend">PASSEPORT</legend>
            <div class="form-group row">
              <label class="col-md-3 text-right">Pays de délivrance: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ demand.document_issuer_country_name }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Numéro: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ demand.document_number }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Type de document: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ demand.document_type | capitalize }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Date de délivrance: </label>
              <label
                v-if="demand.document_delivery_date"
                type="text"
                class="col-md-8 text-left font-weight-bold"
              >
                {{
                  demand.document_delivery_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Date d'expiration: </label>
              <label
                v-if="demand.document_expiry_date"
                type="text"
                class="col-md-8 text-left font-weight-bold"
              >
                {{
                  demand.document_expiry_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}
              </label>
            </div>

            <hr />
            <!-- Champ de commentaire pour affichage simple -->
            <div class="form-group row">
              <label class="col-md-3 text-right">Commentaire: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ demand.comment }}
              </label>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
    <div class="form-group row">
      <!-- <label class="col-md-8"></label> -->
      <div class="col-md-12 text-center">
        <button
          class="btn btn-info"
          style="margin-right: 10px"
          data-toggle="modal"
          data-target="#sendConfirmModal"
        >
          Renvoyer l'eVisa
        </button>
        <button
          class="btn btn-primary"
          style="margin-right: 10px"
          @click="show(demand.id)"
        >
          Voir l'eVisa
        </button>
        <button class="btn btn-secondary" @click="regenerate(demand.id)">
          Régénérer l'eVisa
        </button>
        <router-link
          class="btn btn-dark action-btn-cancel"
          :to="{ name: 'evisas' }"
        >
          Retourner
        </router-link>
      </div>
    </div>

    <div
      class="modal fade"
      id="sendConfirmModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Veuilez entrer un email à mettre en copie.</h5>
            <button
              class="close"
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <input
              type="email"
              v-model="email"
              class="form-control"
              id="email"
              placeholder="Email (ce n'est pas obligatoire)"
              name="email"
            />
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              type="button"
              data-dismiss="modal"
            >
              Annuler
            </button>
            <button
              class="btn btn-primary"
              data-dismiss="modal"
              @click="send(demand.id)"
            >
              Renvoyer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { SET_LOADING } from "@/store/mutations.type";
import { SUCCESS_MESSAGE } from "@/helpers/messages";
import {
  SHOW_EVISA_EVISA,
  REGENERATE_EVISA_EVISA,
  SEND_EVISA_EVISA,
} from "../../store/actions.type";
import { DEMAND_STATUS_TRANSLATION } from "@/helpers/messages";

export default {
  name: "EvisaViewForm",
  data() {
    return {
      country: {},
      message: {
        error: false,
        display: false,
        content: "",
      },
      DEMAND_STATUS_TRANSLATION,
      email: "",
    };
  },
  computed: {
    ...mapGetters({ demand: "evisa" }),
  },
  mounted() {},

  methods: {
    send(id) {
      

      //check email
      if (this.email && !/\S+@\S+\.\S+/.test(this.email)) {
        this.message.content = "Veuillez entrer un email valide";
        this.message.display = true;
        this.message.error = true;
        return;
      }

      
      //if (confirm("Voulez-vous vraiment renvoyer l'eVisa au demandeur?")) {

        let params={};
        params.id=id;
        params.email=this.email
        this.$store.commit(SET_LOADING, true);
        this.$store
          .dispatch(SEND_EVISA_EVISA, params)
          .then(() => {
            this.$store.commit(SET_LOADING, false);
            this.message.content = SUCCESS_MESSAGE;
            this.message.display = true;
          })
          .catch((error) => {
            this.$store.commit(SET_LOADING, false);
            this.message.content = `${error} \n ${JSON.stringify(
              error.errors
            )}`;
            this.message.display = true;
            this.message.error = true;
          });
      //}
    },
    show(id) {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(SHOW_EVISA_EVISA, id)
        .then((response) => {
          this.$store.commit(SET_LOADING, false);
          this.message.content = SUCCESS_MESSAGE;
          this.message.display = true;

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.demand.reference + ".pdf");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.$store.commit(SET_LOADING, false);
          this.message.content = `${error} \n ${JSON.stringify(error.errors)}`;
          this.message.display = true;
          this.message.error = true;
        });
    },
    regenerate(id) {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(REGENERATE_EVISA_EVISA, id)
        .then((response) => {
          this.$store.commit(SET_LOADING, false);
          this.message.content = SUCCESS_MESSAGE;
          this.message.display = true;

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.demand.reference + ".pdf");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.$store.commit(SET_LOADING, false);
          this.message.content = `${error} \n ${JSON.stringify(error.errors)}`;
          this.message.display = true;
          this.message.error = true;
        });
    },
  },
};
</script>
